import {Iso8601} from '@hconnect/uikit'
import {mapValues} from 'lodash'
import moment from 'moment-timezone'

import {SummaryPageData, SummaryPageDataDto} from '../types'

export const mapSummaryPageData = (data: SummaryPageDataDto, timezone: string): SummaryPageData => {
  return {
    productionVolumesResult: {
      ...data.productionVolumesResult,
      productionVolumes: (data.productionVolumesResult.productionVolumes || []).map((volume) => ({
        ...volume,
        lastUpdatedAt: mapValues(volume.lastUpdatedAt, (value: Iso8601) =>
          moment.utc(value).tz(timezone)
        )
      }))
    }
  }
}
